import { render, staticRenderFns } from "./NavigationPane.vue?vue&type=template&id=4b198608&scoped=true&"
import script from "./NavigationPane.vue?vue&type=script&lang=js&"
export * from "./NavigationPane.vue?vue&type=script&lang=js&"
import style0 from "./NavigationPane.vue?vue&type=style&index=0&id=4b198608&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b198608",
  null
  
)

export default component.exports